export const fieldLabels = {
  nameTitle: "Title",
  firstName: "First name",
  surname: "Last name",
  fullName: "Full name",
  telephone: "Telephone",
  email: "Email",
  dateReceived: "Date received",
  customerType: "Customer type",
  directorate: "Directorate",
  summaryEnquiry: "Summary",
  focusEnquiry: "Focus",
  themeEnquiry: "Theme",
  category: "Category",
  contactMethod: "Source",
  learnerType: "Learner type",
  exceptionalCircumstance: "Exceptional circumstance",
  series: "Series",
  year: "Year",
  awardingOrg: "Awarding organisation",
  qualification: "Qualification",
  subject: "Subject",
  centreType: "Centre type",
  centreNumber: "Centre number",
  centreAddressLine1: "Centre address line 1",
  centreAddressLine2: "Centre address line 2",
  centreTown: "Centre Town or City",
  centreName: "Centre name",
  centrePostCode: "Post code",
  centreCountry: "Country",
};
